import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { DormifyLogo } from '../Icons';
import { StyledWrapper, StyledDiv } from './LoadingStyles';

import { ThemeContext } from 'styled-components';

var Loading = function Loading(props) {
  var _useContext = useContext(ThemeContext),
      dormifyPink = _useContext.dormifyPink,
      dormifyBlack = _useContext.dormifyBlack;

  return React.createElement(
    StyledWrapper,
    null,
    React.createElement(
      StyledDiv,
      null,
      React.createElement(DormifyLogo, {
        color: window.location.pathname.includes('rooms-for-guys') ? dormifyBlack : dormifyPink
      }),
      React.createElement(
        'p',
        null,
        props.text || 'Loading...'
      )
    )
  );
};

Loading.propTypes = {
  text: PropTypes.string
};

export default Loading;